import { useQuery } from '@tanstack/react-query';
import { packagesService, TrainerPackage } from '../services/packagesService';

export const trainerPackagesQueryKey = (trainerId?: string) => ['trainer-packages', trainerId];

export function useGetTrainerPackages(trainerId?: string) {
  return useQuery<TrainerPackage[]>({
    queryKey: trainerPackagesQueryKey(trainerId),
    queryFn: async () => {
      if (!trainerId) return [];
      return packagesService.getTrainerPackages(trainerId);
    },
    enabled: Boolean(trainerId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
